module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/en/6-c94923a04b332704265c348c00180560.jpg";